import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { useTranslations } from '@libs/translations';
import { SectionNumber } from '@components/Section-Number';
import { Speeches } from './organism/speeches';

const ArrowLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.5 12H1.5M7.5 19.5L1.5 12L7.5 4.5" stroke="#0E0E0E" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const ArrowRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 12H22.5M16.5 19.5L22.5 12L16.5 4.5" stroke="#0E0E0E" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DirectSpeech = ({ slides = [] }) => {
  const translations = useTranslations();

  return (
    <View id="direct-speech"> 
      <Container>
        <Content>
          <SectionNumber number={''} text={translations.t('site.home.speech.name')} />
          <Top>
            <Title>{translations.t('site.home.speech.title')}</Title>
            <Arrows>
              <Arrow className="custom-prev" data-gtm="slider_prev_click">
                <ArrowLeft />
              </Arrow>
              <Arrow className="custom-next" data-gtm="slider_next_click">
                <ArrowRight />
              </Arrow>
            </Arrows>
          </Top>
          <Description>{translations.t('site.home.speech.description')}</Description>
        </Content>
      </Container>

      <Speeches slides={slides} />
    </View>
  );
};

const View = styled.section`
  height: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: ${Colors.white};
  position: relative;

  @media ${Points.tablet_landscape} {
    padding-bottom: 52px;
    padding-top: 30px;
  }

  @media ${Points.laptop_wide} {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @media ${Points.fullhd} {
    padding-bottom: 130px;
  }
`;
const Container = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;
  display: flex;

  @media ${Points.tablet_landscape} {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 28px;
  }

  @media ${Points.laptop_wide} {
    padding: 0 80px;
    width: 100%;
    max-width: 1600px;
  }

  @media ${Points.fullhd} {
    padding: 0;
  }
`;
const Content = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  margin-bottom: 40px;
`;
const Top = styled.div`
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Title = styled.div`
  font-size: 26px;
  line-height: 1;

  @media ${Points.tablet_landscape} {
    font-size: 34px;
  }

  @media ${Points.laptop_wide} {
    font-size: 54px;
  }
`;
const Arrows = styled.div`
  display: none;
  align-items: center;

  @media ${Points.tablet_portrait} {
    display: flex;
  }
`;
const Arrow = styled.div`
  ${Mixins.transition('background-color')};
  width: 40px;
  height: 40px;
  border: 1px solid ${Colors.main_dark};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;

  @media ${Points.tablet_landscape} {
    width: 64px;
    height: 64px;
    border-radius: 20px;
  }

  &:not(&:last-child) {
    margin-right: 10px;
  }

  &:hover {
    background-color: ${Colors.white_smoke};
  }

  &:active {
    background-color: ${Colors.light_gray};
  }
`;
const Description = styled.div`
  max-width: 470px;
  font-size: 12px;
  line-height: 1.1;
  color: ${Colors.main_gray};

  @media ${Points.laptop_wide} {
    font-size: 14px;
  }
`;
